import React from 'react';
import { NavLink } from "./NavbarElements";

function AuthenticateNav({authenticatedUser, isAdmin}){

    return (
        <>
            { (authenticatedUser === null) &&  
                <NavLink to="/login" activestyle="true">
                    Login
                </NavLink> 
            }

            { (authenticatedUser !== null) &&  
                <NavLink to="/search" activestyle="true"> Search </NavLink> 
            }

            {/* (authenticatedUser !== null) &&  
                <NavLink to="/taxpayer" activestyle="true"> Taxpayer </NavLink> */
            }

            { (authenticatedUser !== null)  &&  
                <NavLink to="/twoFactor" activestyle="true"> Two Factor Authentication </NavLink>
            }

            { isAdmin === true && <NavLink to="/previousClients" activestyle="true"> Clients </NavLink> }

            { isAdmin === true && <NavLink to="/admin" activestyle="true"> Admin </NavLink> }

            { (authenticatedUser !== null)  && 
                <NavLink to="/logout" activestyle="true"> Logout </NavLink>
            }
        </>
    );
}

export default AuthenticateNav;